export default "__VITE_ASSET__7f0472f7__"